import api from "api/axiosInstance"
import { JSX, useEffect, useState } from "react"
import { Navigate } from "react-router-dom"

export function ProtectedRoute({ children }: { children: JSX.Element}){
    const [loading, setLoading] = useState(true)
    const [valid, setValid] = useState(false)

    useEffect(()=>{
        const auth = localStorage.getItem('authToken')
        const token = auth ? JSON.parse(auth).accessToken : null

        if(!token){
            setValid(false)
            setLoading(false)
            return
        }

        setValid(true)
        setLoading(false)
    },[])


    
    

    if(loading) return <div > Проверка токена...</div>
    if(!valid) return <Navigate to='/admin/login' replace/>

    return children
}